import React from 'react';
import { Link } from 'react-router-dom';
import { CarFrontIcon, ChevronRightIcon, HomeIcon, PawPrintIcon, UsersIcon } from 'lucide-react';
import { familyMembers, properties, vehicles } from '../../data/carte';
import { pets } from '../../data/animaux';
const shortcuts = [{
  id: 'famille',
  label: 'Famille',
  count: familyMembers.length,
  unit: 'membre',
  Icon: UsersIcon
}, {
  id: 'proprietes',
  label: 'Adresses',
  count: properties.length,
  unit: 'adresse',
  Icon: HomeIcon
}, {
  id: 'animaux',
  label: 'Animaux',
  count: pets.length,
  unit: 'animal',
  plural: 'animaux',
  Icon: PawPrintIcon
}, {
  id: 'vehicules',
  label: 'Véhicules',
  count: vehicles.length,
  unit: 'véhicule',
  Icon: CarFrontIcon
}];

/** Raccourcis vers les sections de Ma carte : famille, adresses, animaux et véhicules. */
export function CardShortcuts() {
  return <section aria-labelledby="carte-raccourcis-titre" className="mt-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-2807" data-mp="ggqpwqnu72ql">
      <h2 id="carte-raccourcis-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2808" data-mp="bifg2fxjks8d">
        Mon foyer
      </h2>
      <p className="mt-1 text-sm text-slate-600" data-id="element-2809" data-mp="yp2x16bia8ce">Gérés depuis votre carte citoyenne.</p>

      <ul className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-2810" data-mp="kp1uznji8uvc">
        {shortcuts.map(({
        id,
        label,
        count,
        unit,
        plural,
        Icon
      }) => <li key={id} data-id="element-2811" data-mp="pmldx0r5dvtm">
            <Link to={`/ma-carte#${id}`} className="group flex h-full flex-col gap-3 rounded-2xl border border-slate-200 p-4 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2812" data-mp="ppzcrz0lrmwb">
              <span className="flex items-center justify-between" data-id="element-2813" data-mp="6wvh683tqzz2">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-slate-100 text-ville-navy transition-colors duration-150 ease-ville group-hover:bg-white group-hover:text-ville-indigo" aria-hidden="true" data-id="element-2814" data-mp="6v0v2qgth1te">
                  <Icon className="h-5 w-5" data-id="element-2815" data-mp="39zqalucjpom7" />
                </span>
                <ChevronRightIcon className="h-4 w-4 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-2816" data-mp="3a231wy471bbx" />
              </span>
              <span data-id="element-2817" data-mp="30aorhvaper40">
                <span className="block font-bold text-ville-navy" data-id="element-2818" data-mp="307u9sbj2rkea">{label}</span>
                <span className="block text-xs text-slate-500" data-id="element-2819" data-mp="2vcx33b99pn4k">
                  {count} {count > 1 ? plural ?? `${unit}s` : unit}
                </span>
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}